import React from 'react';
import Navbar from './global-components/navbar';
import PageHeader from './global-components/page-header';
import PopularPost from './blog-components/popular-post';
import PostList from './blog-components/post-list';
import Footer from './global-components/footer';
import BlogContact from '../utils/blogContact';

const News = () => {
    return <div>
        <Navbar />
        <PageHeader headertitle="Property News" subheader="News" />
        {/* <PopularPost /> */}
        <PostList />
        <div style={{paddingBottom : '35px'}}>
       <BlogContact />
    </div>
        <Footer />
    </div>
}

export default News

